import AddCollegeAndCourse from "../../Components/Modals/AddCollegeAndCourse";
import AddCollegeExam from "../../Components/Modals/AddCollegeExam";
import Table from "../../Components/Table";
import { deleteCollegeExamById, getAllCollegeExam } from "../../Services/CollegeService";

const CollegeExam = () => {
    const columns = [
        {
            label: "College Name",
            value: "college_name"
        },
        {
            label: "Exam Name",
            value: "exam_name"
        },
        {
            label: "Max Marks",
            value: "max_marks"
        },
        {
            label: "Min Marks",
            value: "min_marks"
        },
        {
            label: "Type",
            value: "type"
        },
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddCollegeExam data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllCollegeExam}
            columns={columns}
            title={"College And Exam Mapping"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteCollegeExamById}
        />
    );
}

export default CollegeExam;